import { required } from "joi";

export const CUSTOMISATION_STYLES = {
  ERROR_BORDER: '1px solid #954104ff',
  SUCCESS_BORDER: '1px solid #03845bff',
  DEFAULT_BORDER: '#5C5C5C',
  ERROR_BG: '#fff5e0ff',
  SUCCESS_BG: '#dcfce7',
  DEFAULT_BG: '#F5F5F5',
  CARD_RADIUS: '9px',
  CARD_PADDING: '12px',
  WHITE_BG: '#fff',
};

export const REQUIRED_TEXT = 'Required'
